import React, { useCallback, useEffect, useState, useContext } from 'react'
import Link from 'next/link'
import Loading from 'Components/loading'
import classnames from 'classnames'
import { Image } from 'Components/view-image'
import Stars from 'New/home/components/dong-che-fen/stars'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import FollowStatus from './follow-status'
import { useCityName } from 'Components/hooks'
import fetch from 'lib/decorated-fetch'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import { logger, metrics } from 'lib/slardar-utils'
import { GlobalStoreContext } from 'Components/store'

const star = require('static/star.png')
const star_black = require('static/star-black.png')
const carBg = require('static/car-bg-l.png')

interface IProps {
  id: number
  name: string
}

const BRAND_TYPE_KEY = 'side-nav-select-car_type'

let followedCars: any[]
let visitedCars: any[]
let hotCars: any[]

const FOLLOW_TYPE = -1
const HISTORY_TYPE = -2
const VIEW_MORE_TYPE = -3

const rehandleList = (list: any[], n: number, m: number) => {
  if (m >= n) {
    return list
  }
  const loop = list.length / n
  const result = []
  for (let i = 0; i < loop; i++) {
    for (let j = 0; j < m; j++) {
      result.push(list[i * n + j])
    }
  }
  return result
}

export default function CarList({ id, name }: IProps) {
  const [type, setType] = useState('全部')
  const [categoryList, setCatgoryList] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(false)

  const { state: globalStore } = useContext(GlobalStoreContext)
  const { userData } = globalStore

  function TypeList() {
    return (
      <ul className="type-list tw-grid tw-gap-0 tw-grid-cols-3 xl:tw-grid-cols-5">
        {categoryList?.map((item: any, index: number) => {
          if (item?.category_name) {
            return (
              <li
                className={classnames('fl g-active-link-text g-one-line-text', {
                  active: type === item?.category_name,
                })}
                onClick={(e) => {
                  e.stopPropagation()
                  // eslint-disable-next-line @typescript-eslint/no-use-before-define
                  setTypeProxy(item?.category_name)
                }}
                key={`type-${index}`}
              >
                {item?.category_name}
              </li>
            )
          }
        })}
        <style jsx>
          {`
            .type-list {
              margin: 4px 0;
              padding: 0 2px;
              position: relative;
            }
            .type-list:after {
              content: '';
              width: 3px;
              position: absolute;
              right: 0;
              top: 0;
              bottom: 0;
              background: #fff;
            }
            li {
              color: #1f2129;
              height: 20px;
              line-height: 20px;
              font-size: 14px;
              text-align: center;
              border-right: 1px solid rgba(216, 216, 216, 0.6);
              margin-bottom: 8px;
              padding: 0 12px;
            }
            li:last-child {
              border-right: none;
            }
            li.active {
              color: #e62021;
            }
          `}
        </style>
      </ul>
    )
  }

  const setTypeProxy = useCallback((type: string) => {
    setType(type)
    sendTeaCommEvent('clk_event', {
      event_id: 'common_select_car_menu_sub_filter',
      button_name: type,
    })
  }, [])

  function Car({ data }: any) {
    let score: any = data?.info?.dcd_score / 100
    score = score > 0 ? score?.toFixed(2) : score
    return (
      <div
        className="side-nav car-wrap tw-col-span-2 xl:tw-col-span-1"
        key={`${data?.info?.series_id}`}
      >
        <Link href={`/auto/series/${data?.info?.series_id}`}>
          <a
            className="no-hover-text"
            target={'_blank'}
            onClick={(e) => {
              e.stopPropagation()
              sendTeaCommEvent('clk_event', {
                event_id: 'common_select_car_menu_series',
                car_series_name: data?.info?.series_name,
                car_series_id: `${data?.info?.series_id}`,
                brand_id: `${id}`,
                brand_name: name,
              })
            }}
          >
            <p className="name g-one-line-text">{data?.info?.series_name}</p>
            <div className="dcar-score">
              <span className="star-bg" />
              {score > 0 ? (
                <>
                  <span className="score">{score}</span>
                  <div className="score-star">
                    <Stars
                      starIcon={star}
                      starVacantIcon={star_black}
                      className="stars"
                      score={score}
                      maxScore={5}
                      starWidth={10}
                      starHeight={10}
                    />
                  </div>
                </>
              ) : (
                <span className="no-score">暂无评分</span>
              )}
            </div>
            <p className="price">指导价: {data?.info?.official_price}</p>
            <div className="img-wrap">
              <Image
                src={data?.info?.image_url}
                width={216}
                height={144}
                lazy={false}
                cusDefaultImg={carBg}
              />
            </div>
          </a>
        </Link>
        <style jsx>
          {`
            .car-wrap {
              position: relative;
              width: 312px;
              height: 88px;
              padding-left: 152px;
              padding-top: 15px;
              font-size: 12px;
              cursor: pointer;
              text-align: left;
            }
            .no-hover-text:hover {
              color: #1f2129;
            }
            .car-wrap:hover {
              background: rgba(255, 204, 50, 0.24);
            }
            .name {
              font-size: 14px;
            }
            .price {
              color: #979aa8;
            }
            .img-wrap {
              position: absolute;
              width: 108px;
              height: 72px;
              top: 8px;
              left: 32px;
            }
            .star-wrap {
              display: inline-block;
              transform: scale(0.86);
              vertical-align: middle;
            }
            .star-bg {
              display: inline-block;
              background-size: cover;
              background-position: center;
              background-image: url(${require('static/dcar-score.png')});
              width: 32px;
              height: 12px;
              vertical-align: middle;
            }
            .score-star {
              padding: 0 2px;
              display: inline-block;
              vertical-align: middle;
            }
            .no-score {
              padding-left: 2px;
              color: #9897a0;
              vertical-align: middle;
            }
            .score {
              padding: 0 2px;
              font-size: 14px;
              vertical-align: middle;
            }
          `}
        </style>
      </div>
    )
  }

  function CarList({ data }: any) {
    if (!data?.category_name) {
      return null
    }
    const getEmptyHint = (type: number) => {
      let emptyHint = null
      if (type === FOLLOW_TYPE) {
        // 我的关注
        emptyHint = <FollowStatus className={`tw-h-124 tw-col-span-2`} />
      } else if (type === HISTORY_TYPE) {
        // 历史浏览
        emptyHint = (
          <p
            className={`tw-col-span-2 tw-text-video-shallow-gray tw-text-14 tw-leading-20 tw-h-84 tw-flex tw-items-center tw-justify-center`}
          >
            暂无浏览历史
          </p>
        )
      }
      return emptyHint
    }

    const list = data?.list || []

    return (
      <div
        className="car-list-item tw-grid tw-grid-cols-2"
        key={`car-list-${data?.category_name}`}
      >
        <div className="title tw-col-span-2">{data?.category_name}</div>
        {list?.map((item: any, index: number) => {
          if (item?.type !== 1002) {
            return getEmptyHint(item?.type)
          }
          return <Car data={item} key={index} />
        })}
        <style jsx>
          {`
            .title {
              font-weight: 500;
              font-size: 16px;
              padding: 0 0 0 36px;
              text-align: left;
            }
          `}
        </style>
      </div>
    )
  }

  const city = useCityName()

  const getRehandleList = (list: any) => {
    return list?.map((e: any) => {
      return {
        info: e,
        type: 1002,
      }
    })
  }

  const getFollowedCars = async () => {
    if (userData?.user_id) {
      try {
        const query = {
          city_name: city,
          count: 50,
          user_id: userData?.user_id,
        }
        const json = await fetch(
          `/motor/pc/car/series/focus_series?${serializeObject(query)}`
        )
        return (
          getRehandleList(json?.data?.list) || [
            {
              type: FOLLOW_TYPE,
            },
          ]
        )
      } catch (err) {
        // no-op
      }
    }

    return [
      {
        type: FOLLOW_TYPE,
      },
    ]
  }
  const getVisitedCars = async () => {
    let visitedSeries = []
    try {
      visitedSeries = JSON.parse(localStorage.getItem('visited_series') || '[]')
    } catch (err) {
      metrics.counter('json.parse.fail', { key: 'visited_series' })
      logger.warn(`[json parse fail] Error parsing json, err: ${err?.message}`)
    }
    if (visitedSeries.length) {
      const query = {
        city_name: city,
        series_ids: visitedSeries.reverse().join(','),
      }
      const json = await fetch(
        `/motor/pc/car/series/selected_series?${serializeObject(query)}`
      )
      return getRehandleList(json.data?.list || [])
    }
    return [
      {
        type: HISTORY_TYPE,
      },
    ]
  }
  const getHotCars = async () => {
    try {
      const query = {
        city_name: city,
        car_count: 6,
        suv_count: 6,
        other_count: 6,
      }
      const json = await fetch(
        `/motor/pc/car/series/hot_series?${serializeObject(query)}`
      )
      return getRehandleList(json?.data?.list || [])
    } catch (err) {
      // no-op
    }
    return []
  }

  const flag = React.useRef(-1)

  useEffect(() => {
    async function fetchData() {
      setLoading(true)
      try {
        if (id === -1) {
          flag.current = -1
          !followedCars && (followedCars = await getFollowedCars())
          !visitedCars && (visitedCars = await getVisitedCars())
          !hotCars && (hotCars = await getHotCars())
          if (flag.current !== -1) {
            return
          }
          let isShowHistory = false
          if (
            visitedCars?.length > 0 &&
            visitedCars?.[0]?.type !== HISTORY_TYPE
          ) {
            isShowHistory = true
          }
          let isShowFollow = false
          if (
            followedCars?.length > 0 &&
            followedCars?.[0]?.type !== FOLLOW_TYPE
          ) {
            isShowFollow = true
          }
          const catgoryList = [
            {
              category_code: 'all',
              category_name: '全部',
              list: [
                {
                  type: 1075,
                  info: {
                    text: '我的关注',
                  },
                },
                ...followedCars.slice(0, 6),
                {
                  type: VIEW_MORE_TYPE,
                  show: followedCars.length > 6,
                  jump: '我的关注',
                },
                {
                  type: 1075,
                  info: {
                    text: '浏览历史',
                  },
                },
                ...visitedCars.slice(0, 6),
                {
                  type: VIEW_MORE_TYPE,
                  show: visitedCars.length > 6,
                  jump: '浏览历史',
                },
                {
                  type: 1075,
                  hide: hotCars.length === 0,
                  info: {
                    text: '热门车系',
                  },
                },
                ...rehandleList(hotCars, 6, 2),
                {
                  type: VIEW_MORE_TYPE,
                  show: hotCars.length > 6,
                  jump: '热门车系',
                },
              ],
            },
            isShowFollow
              ? {
                category_code: '',
                category_name: '我的关注',
                list: followedCars,
              }
              : {},
            isShowHistory
              ? {
                category_code: '',
                category_name: '浏览历史',
                list: visitedCars,
              }
              : {},
            hotCars.length > 0
              ? {
                category_code: '',
                category_name: '热门车系',
                list: hotCars,
              }
              : {},
          ]
          setCatgoryList(catgoryList)
          setType('全部')
          setLoading(false)
        } else {
          flag.current = id
          const data = await getCarList(id)
          if (flag.current !== id) {
            return
          }
          setCatgoryList(data?.category_list)
          const defaultType = data?.category_list?.[0]?.['category_name']
          // const type = window?.localStorage?.getItem(BRAND_TYPE_KEY) || ''
          // if (type) {
          //   // 看用户上次缓存的type 这次请求的是否存在
          //   const allTypes = data?.category_list.map((item: any) => item?.category_name)
          //   if (allTypes?.indexOf(type) > -1) {
          //     setType(type)
          //   } else {
          //     setType(defaultType)
          //   }
          // } else {
          //   setType(defaultType)
          // }
          setType(defaultType)
          setLoading(false)
        }
      } catch (error) {
        setLoading(false)
        setCatgoryList([])
      }
    }
    fetchData()
  }, [id])

  const getText = (type: string) => {
    switch (type) {
    case '我的关注':
      return '查看更多关注'
    case '浏览历史':
      return '查看更多历史'
    case '热门车系':
      return '查看更多热门'
    }
  }

  const renderAllCars = (list: any) => (
    <div className="car-list-item tw-grid tw-grid-cols-2">
      {list?.map((e: any, index: number) => {
        if (e?.type === 1075 && !e?.hide) {
          return (
            <div
              className="tw-text-16 tw-pl-36 tw-font-semibold tw-text-left tw-col-span-2"
              key={e?.unique_id_str}
            >
              {e?.info?.text}
            </div>
          )
        } else if (e?.type === 1002) {
          return <Car data={e} key={index} />
        } else if (e?.type === FOLLOW_TYPE) {
          // 我的关注
          return (
            <FollowStatus className={`tw-h-84 lg:tw-h-124 tw-col-span-2`} />
          )
        } else if (e?.type === HISTORY_TYPE) {
          // 浏览历史
          return (
            <p
              className={`tw-col-span-2 tw-text-video-shallow-gray tw-text-14 tw-leading-20 tw-h-84 tw-flex tw-items-center tw-justify-center`}
            >
              暂无浏览历史
            </p>
          )
        } else if (e?.type === VIEW_MORE_TYPE && e?.show) {
          return (
            <a
              className={`view-more tw-col-span-2 tw-mr-24 xl:tw-mr-41 tw-flex tw-items-center tw-justify-end tw-cursor-pointer tw-text-14  tw-text-common-gray  hover:tw-text-common-black`}
              onClick={() => {
                setType(e?.jump)
                sendTeaCommEvent('clk_event', {
                  event_id: 'common_select_car_menu_btn',
                  button_name:
                    e?.jump === '我的关注'
                      ? 'all_follow'
                      : e?.jump === '浏览历史'
                        ? 'all_history'
                        : 'more_pop_cars',
                  brand_name: '热门推荐',
                })
              }}
            >
              <span className={`tw-leading-20 tw-mr-2 `}>
                {getText(e?.jump)}
              </span>
              <span className={`tw-w-16 tw-h-16 tw-bg-cover tw-bg-center`} />
              <style jsx>
                {`
                  .view-more > span:last-child {
                    background-image: url('${require('static/right-arrow-gray.svg')}');
                  }
                  .view-more:hover > span:last-child {
                    background-image: url('${require('static/right-arrow-black.svg')}');
                  }
                `}
              </style>
            </a>
          )
        }
      })}
    </div>
  )

  return (
    <div className="car-list-wrap">
      {id && categoryList.length && !loading ? (
        <>
          <TypeList />
          <div className="car-list-content g-cus-scroll-bar">
            {type === '全部' ? (
              <>
                {renderAllCars(
                  categoryList?.find((e: any) => e?.category_code === 'all')
                    ?.list || []
                )}
              </>
            ) : (
              categoryList?.map((item: any, index: number) => {
                if (item?.category_name === type) {
                  return <CarList key={`car-list-${index}`} data={item} />
                }
              })
            )}
          </div>
        </>
      ) : loading ? (
        <div className="bg-loading-no-pic">
          <Loading />
        </div>
      ) : (
        <div className="bg-loading">请选择左侧品牌</div>
      )}
      <style jsx>
        {`
          .car-list-wrap {
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            padding-bottom: 16px;
          }
          .car-list-content {
            height: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            overscroll-behavior: contain;
          }
          .bg-loading {
            position: absolute;
            top: 50%;
            left: 50%;
            text-align: center;
            padding-top: 100px;
            width: 100px;
            height: 120px;
            transform: translate(-50%, -50%);
            background-image: url(${require('./static/bg.png')});
            background-repeat: no-repeat;
            background-position: 0 0;
            background-size: 100px 100px;
            color: #979aa8;
            font-size: 14px;
          }
          .bg-loading-no-pic {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        `}
      </style>
    </div>
  )
}

// 只有全部分类里面有具体数据，其他类型只有id，需要补充
function supplementList(data: any) {
  const tmpObj: {
    [key: string]: string
  } = {} // id
  // eslint-disable-next-line no-unused-expressions
  data?.category_list.forEach((item: any) => {
    if (item?.category_code === 'all') {
      // eslint-disable-next-line no-unused-expressions
      item?.list?.forEach((car: any) => {
        if (car?.info?.series_id) {
          tmpObj[car?.info?.series_id as string] = car
        }
      })
    } else {
      if (item?.series_id_list?.length) {
        // eslint-disable-next-line no-unused-expressions
        item?.series_id_list.forEach((id: number) => {
          if (tmpObj[id]) {
            if (!item?.list) {
              item.list = []
            } else {
              item.list.push(tmpObj[id])
            }
          }
        })
      }
    }
  })
}

async function getCarList(id: number) {
  const json = await fetch(
    `/motor/pc/car/brand/get_brand_series_list?brand_id=${id}&no_sales=0&show_historical_series=1&category_group_optimize=true`
  )
  supplementList(json.data)
  return json.data
}
